
























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'

@Component
export default class PriceView extends Vue {
  @Prop({ required: true }) price: number | string | null
  @Prop() salePrice: number | null | string
  @Prop() regularPrice: number | null | string
  @Prop() discountPercent: number | null
  //---
  @Prop({ default: false }) noCurrency: boolean
  @Prop({ default: 'xs' }) gutter: string


  get _price() {
    return this._getString(this.price)
  }

  get _regularPrice() {
    return this._getString(this.regularPrice)
  }

  get _salePrice() {
    return this._getString(this.salePrice)
  }

  _getString(value) {
    return (value)
      ? (typeof value == 'string' && !value.includes(',')) ? Number(value).toLocaleString() : value.toLocaleString()
      : ''
  }

  get gutterSize() {
    return `q-gutter-x-${this.gutter}`
  }

  getNumber(value) {
    return (typeof value == 'string') ? Number(value.replaceAll(',', '')) : value
  }

  get showSalePrice() {
    return this.salePrice
      && (this.getNumber(this.salePrice) < this.getNumber(this.regularPrice))
      && (this.getNumber(this.salePrice) > 0)
  }
}
